import React from 'react';

interface IGuideListProps {
  content: string;
  active: boolean;
  index: number;
}

const Guidelist = ({ content, active, index }: IGuideListProps) => {
  const isActive = index == 0 ? true : active;

  return (
    <li className={`guide-stage-list__item ${isActive ? 'active' : ''}`}>
      <span>{index + 1 + '.'}</span> {content}
    </li>
  );
};

export default Guidelist;
